// extracted by mini-css-extract-plugin
export default {"hideTooltip":"q_-z","fadeIn":"r_-z","delay":"s_-z","recommendedSizeTooltip":"t_-z"};